function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import utils from '../../common/utils/index.js';
import { GalleryComponent } from '../galleryComponent';

var ItemHover = /*#__PURE__*/function (_GalleryComponent) {
  _inheritsLoose(ItemHover, _GalleryComponent);

  function ItemHover() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = ItemHover.prototype;

  _proto.getHoverClass = function getHoverClass() {
    var _this$props = this.props,
        styleParams = _this$props.styleParams,
        forceShowHover = _this$props.forceShowHover;
    var hoverClass = ['gallery-item-hover'];
    hoverClass.push('fullscreen-' + (styleParams.fullscreen ? 'enabled' : 'disabled'));

    if (utils.isUndefined(styleParams.itemOpacity)) {
      //if gallery was just added to the page, and it's settings were never opened,
      //the styles of opacity and background were not set (are undefined),
      //so we are using the default background & opacity (is scss under .gallery-item-hover.default)
      hoverClass.push('default');
    }

    if (forceShowHover) {
      //in mobile, when item is hovered (tapped, with all the right configurations), forceShowHover is true
      hoverClass.push('force-hover');
    } else if (utils.isMobile()) {
      hoverClass.push('hide-hover');
    }

    return hoverClass.join(' ');
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        shouldHover = _this$props2.shouldHover,
        imageDimensions = _this$props2.imageDimensions,
        actions = _this$props2.actions,
        idx = _this$props2.idx,
        styleParams = _this$props2.styleParams;

    if (!shouldHover) {
      return null;
    }

    var hoverClass = this.getHoverClass();

    var _ref = imageDimensions || {},
        marginLeft = _ref.marginLeft,
        marginTop = _ref.marginTop,
        width = _ref.width,
        height = _ref.height,
        restOfDimensions = _objectWithoutPropertiesLoose(_ref, ["marginLeft", "marginTop", "width", "height"]); //width and height will be taken from the gallery.scss and not be inline


    return /*#__PURE__*/React.createElement("div", {
      className: hoverClass,
      key: 'item-hover-' + idx,
      "data-hook": 'item-hover-' + idx,
      "aria-hidden": true,
      style: imageDimensions && imageDimensions.borderRadius ? {
        borderRadius: imageDimensions.borderRadius
      } : {}
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        height: '100%'
      },
      onTouchStart: actions.handleItemMouseDown,
      onTouchEnd: actions.handleItemMouseUp
    }, this.props.renderCustomInfo ? /*#__PURE__*/React.createElement("div", {
      className: "gallery-item-hover-inner"
    }, this.props.renderCustomInfo()) : null));
  };

  return ItemHover;
}(GalleryComponent);

export { ItemHover as default };